// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { VideoCameraAddOutlined } from '@ant-design/icons';

// type
import { NavItemType } from '@trendiolive/trendio-selfcare-ui-kit';

// icons
const icons = { VideoCameraAddOutlined };

// ==============================|| MENU ITEMS - SAMPLE PAGE ||============================== //

const videoAi: NavItemType = {
  id: 'video-ai',
  title: <FormattedMessage id="video-ai" />,
  type: 'group',
  url: '/video-ai',
  icon: icons.VideoCameraAddOutlined
};

export default videoAi;
